import { Application, Controller } from '@hotwired/stimulus'

let stimulus
if (!globalThis.stimulus) {
  stimulus = Application.start()
  globalThis.stimulus = stimulus
} else {
  stimulus = globalThis.stimulus
}

export { Application, Controller }
export default stimulus
